import type { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import { Children } from 'react';
import { isFragment } from 'react-is';
import { cn } from 'src/utils/cn';

export const DataItems: FC<{ children: ReactNode }> = ({ children }) => {
  // while uncommon, it should be safe to calculate an index here
  let index = 0;
  return (
    <>
      {Children.map(children, function recursive(child): ReactNode {
        if (isFragment(child)) {
          return Children.map(child.props.children, recursive);
        } else if (child) {
          const isOdd = index % 2 === 0;
          index += 1;
          return (
            <div data-slot className="legacy:leading-[1.6]">
              {child}
              {isOdd && ':'}
            </div>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};

export const DataList: FC<
  ComponentPropsWithoutRef<'div'> & {
    template?: string;
  }
> = ({ template = 'auto 1fr', ...props }) => {
  return (
    <div
      className={cn(`
        grid gap-x-lg gap-y-xs wrap-break-word
        legacy:gap-x-[1rem] legacy:gap-y-0
        [&>*:not([data-slot])]:col-span-2 [&>*:not([data-slot])]:col-start-1
      `)}
      style={{ gridTemplateColumns: template }}
      {...props}
    />
  );
};
